import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import WhiteModal from "../../Components/molecules/Modal/Modal";
import { corpus, Key, q } from "../../helpers/Arrays";
import { listFilesGoogle } from "../../helpers/functions";
import { Images } from "../../helpers/Images";
import { Cloudinary } from "@cloudinary/url-gen";
import { GalleryArray } from "../../helpers/gallery";
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined";
import "./Gallery.css";

const HighlightImage = ({ src, index, onClick }) => (
  <Box
    className={`bento-item ${"bento-item--standard"}`}
    onClick={onClick}
    sx={{
      position: "relative",
      borderRadius: "16px",
      overflow: "hidden",
      cursor: "pointer",
      border: "1px solid rgba(255, 255, 255, 0.35)",
      boxShadow: "0 16px 40px rgba(0, 0, 0, 0.22)",
      // minHeight: { xs: "180px", sm: "200px" },
      "&:hover .highlight-image": {
        transform: "scale(1.06)",
      },
      "&:hover .highlight-overlay": {
        opacity: 1,
      },
    }}
  >
    <Box
      component="img"
      className="highlight-image"
      src={src}
      alt={`We Do Challenge highlight ${index + 1}`}
      loading="lazy"
      sx={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block",
        transition: "transform 0.5s ease",
      }}
    />
    <Box
      className="highlight-overlay"
      sx={{
        position: "absolute",
        inset: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "linear-gradient(180deg, rgba(10, 14, 24, 0.05) 0%, rgba(10, 14, 24, 0.55) 100%)",
        opacity: { xs: 0.35, md: 0 },
        transition: "opacity 0.35s ease",
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "rgba(255, 255, 255, 0.92)",
          color: "#23aef4",
          boxShadow: "0 8px 24px rgba(10, 14, 24, 0.15)",
        }}
      >
        <PhotoLibraryOutlinedIcon sx={{ fontSize: 22 }} />
      </Box>
    </Box>
  </Box>
);

const GalleryTemplate = () => {
  const [images, setImages] = useState();
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // useEffect(() => {
  //   listFilesGoogle(setImages, 1000, setLoading);
  // }, []);

  // useEffect(() => {
  //   axios
  //     .get(`https://api.cloudinary.com/v1_1/dkntc73vq/resources/image`, {
  //       headers: {
  //         Authorization: `Basic ${Buffer.from(
  //           "155741483113429" + ":" + "xCXq0Vto3LplpNFS4G3OJX2zsIA"
  //         ).toString("base64")}`,
  //         "Access-Control-Allow-Origin": "*",
  //       },
  //     })
  //     .then((res) => {
  //       console.log(res);
  //     });
  //   // .catch((err) => refreshAccess())
  // }, []);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
          maxWidth: "1500px",
          margin: "auto",
        }}
      >
        <Typography
          variant={"h1"}
          sx={{
            color: "primary.darker",
            fontSize: { xs: "34px", sm: "42px" },
            lineHeight: 1.15,
            fontWeight: 800,
            letterSpacing: "-0.02em",
            textAlign: { xs: "center" },
          }}
        >
          We Do Challenge Gallery
        </Typography>
        <Box
          sx={{
            height: "4px",
            width: { xs: "80px", md: "150px" },
            borderRadius: "999px",
            background: "linear-gradient(90deg, #23aef4 0%, #c11a83 100%)",
            margin: "10px auto 50px",
          }}
        />
        <Box className="highlights-bento">
          {GalleryArray.map((src, i) => (
            <HighlightImage
              key={src}
              src={src}
              index={i}
              onClick={() => {
                setSelectedImage(src);
                handleOpen();
              }}
            />
          ))}
        </Box>
      </Box>
      <WhiteModal
        open={open}
        handleClose={handleClose}
        inSide={
          <Box sx={{ width: "60vw" }}>
            <img
              alt="image"
              loading={"lazy"}
              src={selectedImage}
              style={{ maxWidth: "100%", borderRadius: "10px" }}
            />
          </Box>
        }
      />
    </>
  );
};

export default GalleryTemplate;
